import { ToastOptions } from 'shared/types/toast';

// Global toast instance - sẽ được set từ React component
let globalToastInstance: {
  show: (options: ToastOptions) => string;
  hide: (id: string) => void;
  hideAll: () => void;
} | null = null;

// Simple debounce mechanism để tránh hiện toast 2 lần
const lastToastMap = new Map<string, number>();
const DEBOUNCE_DELAY = 500; // 500ms debounce

// Set global toast instance (được gọi từ React component)
export const setGlobalToastInstance = (toastInstance: typeof globalToastInstance) => {
  globalToastInstance = toastInstance;
};

// Helper functions để sử dụng trong file .ts
export const showStepXToast = (options: ToastOptions): string | null => {
  if (!globalToastInstance) {
    return null;
  }
  
  // Tạo debounce key từ title và description
  const debounceKey = `${options.title || ''}-${options.description || ''}`;
  const now = Date.now();
  
  // Check if same toast was shown recently
  if (debounceKey && debounceKey !== '-') {
    const lastShown = lastToastMap.get(debounceKey);
    if (lastShown && (now - lastShown) < DEBOUNCE_DELAY) {
      return null; // Skip duplicate toast
    }
    lastToastMap.set(debounceKey, now);
  }
  
  return globalToastInstance.show(options);
};

export const hideStepXToast = (id: string): void => {
  if (!globalToastInstance) {
    return;
  }
  globalToastInstance.hide(id);
};

export const hideAllStepXToasts = (): void => {
  if (!globalToastInstance) {
    return;
  }
  globalToastInstance.hideAll();
};

